module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 623796760708,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07786061532623291,
		"cl_weight": 0.25479016747035416,
		"fossil_bank_score": 31.0129,
		"fossil_insure_score": 21.8263,
		"wff_mil_weight": 0.03651268061127668,
		"mmc_weight": 0.03651268061127668,
		"cm_weight": 0.014395149750011245,
		"nw_weight": 0.02426225530178818,
		"wff_civ_weight": 0.009295281958037575,
		"gm_weight": 0.0012830237142066995,
		"gr_weight": 0.008012258243830875,
		"t_all_weight": 0.01809552417114264,
		"to_weight": 0.007249691713980882,
		"tm_weight": 0.010845832457161758,
		"po_producer_weight": 0.0016253422549292696,
		"po_financier_weight": 0.027476821453426132,
		"po_consumer_weight": 0.11133636027689021,
		"pp_weight": 0.19407171034240236,
		"borders_weight": 0.18132822724601952,
		"pp_high_weight": 0.003262101343225843,
		"borders_high_weight": 0.018974152663680625,
		"pff_all_weight": 0.2257580634879352,
		"pff_all_high_weight": 0.018974152663680625,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.804601824177965,
		"gef_score_a": 26.457961905414777,
		"gef_score_b": 9.295813063192906,
		"gef_score_c": 18.377152366764854,
		"gef_score_d": 0.6736744887975236,
		"gef_score_a_norm": 66.14490476353694,
		"gef_score_b_norm": 30.986043543976354,
		"gef_score_c_norm": 91.88576183382426,
		"gef_score_d_norm": 6.736744887975235,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": 5.08314,
		"trailing_return_m3": 10.93414,
		"trailing_return_m6": 6.18625,
		"trailing_return_y1": 15.12664,
		"trailing_return_y3": 19.67711,
		"trailing_return_y5": 16.60573,
		"trailing_return_y10": 13.60831,
		"trailing_return_y15": 14.80973,
		"trailing_return_y20": 10.68343,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 15862438621,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.0761143024605031,
		"cl_weight": 0.2235914966154116,
		"fossil_bank_score": 27.3418,
		"fossil_insure_score": 19.3751,
		"wff_mil_weight": 0.03843392356154874,
		"mmc_weight": 0.03843392356154874,
		"cm_weight": 0.01383010361481589,
		"nw_weight": 0.023886835630720037,
		"wff_civ_weight": 0.008538365693349969,
		"gm_weight": 0.0011928427136076631,
		"gr_weight": 0.007345522979742308,
		"t_all_weight": 0.015911102409312806,
		"to_weight": 0.006430668016421122,
		"tm_weight": 0.009480434392891689,
		"po_producer_weight": 0.0014214634754942915,
		"po_financier_weight": 0.024167441015996,
		"po_consumer_weight": 0.09975971326808121,
		"pp_weight": 0.1725723002377748,
		"borders_weight": 0.16203286289829302,
		"pp_high_weight": 0.00317154150794295,
		"borders_high_weight": 0.01782267591361862,
		"pff_all_weight": 0.2018011484441901,
		"pff_all_high_weight": 0.017831949198226126,
		"pff_all_extreme_weight": 0.00008983865026071768,
		"gef_score_norm": 53.25255043480151,
		"gef_score_a": 25.860817372049482,
		"gef_score_b": 8.736108823957464,
		"gef_score_c": 18.046342570895757,
		"gef_score_d": 0.6092816678917731,
		"gef_score_a_norm": 64.65204343012371,
		"gef_score_b_norm": 29.12036274652488,
		"gef_score_c_norm": 90.23171285447879,
		"gef_score_d_norm": 6.092816678917731,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": 5.05792,
		"trailing_return_m3": 10.93048,
		"trailing_return_m6": 5.64932,
		"trailing_return_y1": 15.07128,
		"trailing_return_y3": 18.88617,
		"trailing_return_y5": 15.76786,
		"trailing_return_y10": 12.77483,
		"trailing_return_y15": 14.26929,
		"trailing_return_y20": 10.3608,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 63717647952,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.07057755725258257,
		"cl_weight": 0.003189110526244142,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.03474279363232204,
		"mmc_weight": 0.03474279363232204,
		"cm_weight": 0.0035484170041263697,
		"nw_weight": 0.01065383688303108,
		"wff_civ_weight": 0.00181451492627954,
		"gm_weight": 0.0006502502118660015,
		"gr_weight": 0.0011642647144135385,
		"t_all_weight": 0.0015933931743933247,
		"to_weight": 0.0010662087809913642,
		"tm_weight": 0.0005271843934019605,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.003323045363026491,
		"pp_weight": 0.004665652668547614,
		"borders_weight": 0.010153083255876758,
		"pp_high_weight": 0.002839385278301767,
		"borders_high_weight": 0.0042212116091608015,
		"pff_all_weight": 0.012202729130304851,
		"pff_all_high_weight": 0.004444590093343046,
		"pff_all_extreme_weight": 0.0021722670862599543,
		"gef_score_norm": 37.66488117020402,
		"gef_score_a": 19.310902996358923,
		"gef_score_b": 3.3564826046740572,
		"gef_score_c": 14.966459352114796,
		"gef_score_d": 0.031036217061342502,
		"gef_score_a_norm": 48.277257490897306,
		"gef_score_b_norm": 11.188275348913525,
		"gef_score_c_norm": 74.83229676057398,
		"gef_score_d_norm": 0.310362170613425,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 5.39832,
		"trailing_return_m3": 8.4639,
		"trailing_return_m6": -1.8214,
		"trailing_return_y1": 7.52463,
		"trailing_return_y3": 9.88333,
		"trailing_return_y5": 9.90884,
		"trailing_return_y10": 7.06081,
		"trailing_return_y15": 10.30648,
		"trailing_return_y20": 7.73559,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 41049029418,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07636485509137107,
		"cl_weight": 0.23330222043232599,
		"fossil_bank_score": 28.5469,
		"fossil_insure_score": 20.2193,
		"wff_mil_weight": 0.038519247878056814,
		"mmc_weight": 0.038519247878056814,
		"cm_weight": 0.014285463381136537,
		"nw_weight": 0.024428432827533986,
		"wff_civ_weight": 0.00881291834727822,
		"gm_weight": 0.0012206311671848328,
		"gr_weight": 0.007592287180093387,
		"t_all_weight": 0.01654201653008811,
		"to_weight": 0.00666165821839925,
		"tm_weight": 0.009880358311688861,
		"po_producer_weight": 0.001488490604850707,
		"po_financier_weight": 0.025235011650961616,
		"po_consumer_weight": 0.1040223398047968,
		"pp_weight": 0.1799433703557826,
		"borders_weight": 0.1686832967889797,
		"pp_high_weight": 0.0031927518534311697,
		"borders_high_weight": 0.01841996471065646,
		"pff_all_weight": 0.21009611053878435,
		"pff_all_high_weight": 0.01841996471065646,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.71590721170957,
		"gef_score_a": 26.054946834282667,
		"gef_score_b": 8.897518149697149,
		"gef_score_c": 18.13674013890973,
		"gef_score_d": 0.6267020888126316,
		"gef_score_a_norm": 65.13736708570667,
		"gef_score_b_norm": 29.65839383232383,
		"gef_score_c_norm": 90.68370069454865,
		"gef_score_d_norm": 6.267020888126315,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": 5.04966,
		"trailing_return_m3": 11.06246,
		"trailing_return_m6": 6.03629,
		"trailing_return_y1": 15.48803,
		"trailing_return_y3": 19.43098,
		"trailing_return_y5": 16.14325,
		"trailing_return_y10": 13.2039,
		"trailing_return_y15": 14.58951,
		"trailing_return_y20": 10.57899,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 64294013438,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.10672073228217316,
		"cl_weight": 0.12569183388121577,
		"fossil_bank_score": 29.1484,
		"fossil_insure_score": 22.1441,
		"wff_mil_weight": 0.05182808922568649,
		"mmc_weight": 0.05182808922568649,
		"cm_weight": 0.02554624887444551,
		"nw_weight": 0.028141426954144722,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.01670031201992826,
		"to_weight": 0.008385115417512223,
		"tm_weight": 0.008315196602416038,
		"po_producer_weight": 0.013961002797528311,
		"po_financier_weight": 0.08368158225629799,
		"po_consumer_weight": 0.10214069406388429,
		"pp_weight": 0.015250552747248236,
		"borders_weight": 0.031278092448956386,
		"pp_high_weight": 0.0008417687220592107,
		"borders_high_weight": 0.007094453959024026,
		"pff_all_weight": 0.03389394549464705,
		"pff_all_high_weight": 0.007936222681083236,
		"pff_all_extreme_weight": 0.00028487034935059636,
		"gef_score_norm": 58.09398342755523,
		"gef_score_a": 25.610094464360355,
		"gef_score_b": 13.681979245734173,
		"gef_score_c": 17.480790733238415,
		"gef_score_d": 1.3211189842152948,
		"gef_score_a_norm": 64.02523616090089,
		"gef_score_b_norm": 45.606597485780576,
		"gef_score_c_norm": 87.40395366619207,
		"gef_score_d_norm": 13.211189842152947,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 2.51948,
		"trailing_return_m3": 11.53661,
		"trailing_return_m6": 20.40288,
		"trailing_return_y1": 18.17437,
		"trailing_return_y3": 15.90566,
		"trailing_return_y5": 11.2897,
		"trailing_return_y10": 6.53732,
		"trailing_return_y15": 7.4824,
		"trailing_return_y20": 5.77687,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 18247266369,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.09656872041122279,
		"cl_weight": 0.1343158555805478,
		"fossil_bank_score": 8.6502,
		"fossil_insure_score": 6.9222,
		"wff_mil_weight": 0.035803986431927906,
		"mmc_weight": 0.035803986431927906,
		"cm_weight": 0.006290721324943582,
		"nw_weight": 0.019161243385908567,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.003267049603201719,
		"to_weight": 0.003267049603201719,
		"tm_weight": 0,
		"po_producer_weight": 0.010180076536282057,
		"po_financier_weight": 0.01942320964161536,
		"po_consumer_weight": 0.009542287164139998,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 47.01714821843184,
		"gef_score_a": 22.20499081280715,
		"gef_score_b": 7.61461204170127,
		"gef_score_c": 16.60371456331174,
		"gef_score_d": 0.5938308006215356,
		"gef_score_a_norm": 55.51247703201787,
		"gef_score_b_norm": 25.382040139004236,
		"gef_score_c_norm": 83.0185728165587,
		"gef_score_d_norm": 5.9383080062153555,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": 6.61991,
		"trailing_return_m3": 11.28356,
		"trailing_return_m6": 15.59086,
		"trailing_return_y1": 15.70522,
		"trailing_return_y3": 8.99599,
		"trailing_return_y5": 6.11107,
		"trailing_return_y10": 4.17853,
		"trailing_return_y15": 3.82173,
		"trailing_return_y20": 5.70985,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 6420304889,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.11376980789484796,
		"cl_weight": 0.12693821905116182,
		"fossil_bank_score": 30.4454,
		"fossil_insure_score": 17.1463,
		"wff_mil_weight": 0.04554554797754404,
		"mmc_weight": 0.04554554797754404,
		"cm_weight": 0.01799980499596168,
		"nw_weight": 0.025616965968505413,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.011514041791968004,
		"to_weight": 0.00624974439298825,
		"tm_weight": 0.005264297398979752,
		"po_producer_weight": 0.011797657628463102,
		"po_financier_weight": 0.05850959968946393,
		"po_consumer_weight": 0.06889161969921617,
		"pp_weight": 0.011422425254214674,
		"borders_weight": 0.020860598510188472,
		"pp_high_weight": 0.0005312755752188583,
		"borders_high_weight": 0.005575961806067548,
		"pff_all_weight": 0.0243511961220496,
		"pff_all_high_weight": 0.006107237381286406,
		"pff_all_extreme_weight": 0.00017778847500157454,
		"gef_score_norm": 57.00214560150042,
		"gef_score_a": 25.518971780263175,
		"gef_score_b": 12.813528633826104,
		"gef_score_c": 17.44878191349615,
		"gef_score_d": 1.2208632739085281,
		"gef_score_a_norm": 63.79742945065794,
		"gef_score_b_norm": 42.71176211275368,
		"gef_score_c_norm": 87.24390956748074,
		"gef_score_d_norm": 12.208632739085282,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 3.78159,
		"trailing_return_m3": 11.72746,
		"trailing_return_m6": 18.65745,
		"trailing_return_y1": 18.21785,
		"trailing_return_y3": 13.8628,
		"trailing_return_y5": 10.08603,
		"trailing_return_y10": 6.03834,
		"trailing_return_y15": 6.51507,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 22225947793,
		"grade_fossil": 4,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 3,
		"c2f5coogutweight": 0.08710177280314904,
		"cl_weight": 0.20272068142387767,
		"fossil_bank_score": 30.6043,
		"fossil_insure_score": 16.9138,
		"wff_mil_weight": 0.04002920420684871,
		"mmc_weight": 0.04002920420684871,
		"cm_weight": 0.01593067201879167,
		"nw_weight": 0.024627440041626203,
		"wff_civ_weight": 0.006013377730346952,
		"gm_weight": 0.0007979778783312018,
		"gr_weight": 0.00521539985201575,
		"t_all_weight": 0.015306999175919043,
		"to_weight": 0.006770506792522426,
		"tm_weight": 0.008536492383396618,
		"po_producer_weight": 0.005108434008524204,
		"po_financier_weight": 0.038508379535417886,
		"po_consumer_weight": 0.09399628799035455,
		"pp_weight": 0.12081787525625458,
		"borders_weight": 0.11936245185225437,
		"pp_high_weight": 0.0022605412260022226,
		"borders_high_weight": 0.014025226617253079,
		"pff_all_weight": 0.14551970969665132,
		"pff_all_high_weight": 0.014215454924437118,
		"pff_all_extreme_weight": 0.00006495392309120716,
		"gef_score_norm": 55.15418247209995,
		"gef_score_a": 26.052788920929892,
		"gef_score_b": 10.21664060947363,
		"gef_score_c": 18.075375291210477,
		"gef_score_d": 0.8093776504785922,
		"gef_score_a_norm": 65.13197230232473,
		"gef_score_b_norm": 34.055468698245434,
		"gef_score_c_norm": 90.37687645605239,
		"gef_score_d_norm": 8.093776504785923,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 4.63934,
		"trailing_return_m3": 11.45457,
		"trailing_return_m6": 10.34386,
		"trailing_return_y1": 16.41744,
		"trailing_return_y3": 17.37097,
		"trailing_return_y5": 13.704,
		"trailing_return_y10": 10.15144,
		"trailing_return_y15": 10.75342,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-06-30T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 1002
// module chunks = 0